import { red } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

// A custom theme for this app
let theme = createMuiTheme(
  {
  overrides: {
    MuiDialogTitle: {
      root: {
        color: '#fff',
        background: '#556cd6'
      }
    },
    MuiGrid: {
      root: {
        paddingTop: '1em',
        //borderStyle: 'solid',
        //borderWidth: '1px'
      }
    },
    MuiLink: {
      root: {
        fontFamily: 'Roboto',
        fontSize: '1.1em'
      }
    },
    MuiMenuItem: {
      root: {
        //Перенос рядков в выпадающих списках
        whiteSpace: "normal"
      }
    },
    MuiSelect: {
      selectMenu: {
        //Чтоб длинные строки в комбиках без обрезаний отображались
        whiteSpace: "normal"
      }
    },
    MuiInputBase: {
      input: {
        //Цвет заблокированных елементов не должен отличаться от цвета нормальных
        color: "rgba(0, 0, 0, 0.87)"
      }
    },
    MuiInputLabel: {
      root: {
        "&$disabled": {
          color: '#556cd6'
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red[900],
    },
    background: {
      default: '#fff',
    }
  },
});

theme = responsiveFontSizes(theme);

export default theme;